@switch (mode) { @case (LabelMode.DEFAULT) {
<ng-container [ngTemplateOutlet]="default"></ng-container>
} @case (LabelMode.INLINE) {
<ng-container [ngTemplateOutlet]="inline"></ng-container>
} @case (LabelMode.NO_LABEL) {
<ng-container [ngTemplateOutlet]="input"></ng-container>
} }

<ng-template #input>
  <ng-select
    #selectRef
    [id]="name"
    class="{{ inputClass }} w-100"
    [ngClass]="{ error: isError }"
    [appendTo]="appendTo"
    [formControl]="form"
    [items]="options"
    bindLabel="{{ bindLabel }}"
    bindValue="{{ bindValue }}"
    [placeholder]="placeholder | translate"
    [loading]="isLoading"
    [clearable]="clearable"
    [searchable]="searchable"
    groupBy="{{ groupBy }}"
    [multiple]="isMultiple"
    [selectableGroup]="selectableGroup"
    [selectableGroupAsModel]="selectableGroupAsModel"
    [closeOnSelect]="closeOnSelect"
    [clearSearchOnAdd]="clearSearchOnAdd"
    [searchFn]="onSearchFn"
    (click)="onSelectClick()"
    (clear)="onClearSelected()"
    (search)="onSearch($event)"
    (change)="onInputChange($event)"
  >
    @if (showSelectAll && isMultiple) {
    <ng-template ng-header-tmp>
      <div class="app-select-dropdown-header">
        <button
          type="button"
          class="app-select-select-all-button"
          (click)="toggleCheckAll(true); $event.stopPropagation()"
        >
          {{ selectAllLabel | translate }}
        </button>
      </div>
    </ng-template>
    }
    @if (multilineOption) {
    <ng-template ng-option-tmp let-item="item">
      <button
        type="button"
        class="app-select-multiline-option"
        (pointerdown)="onMultilineOptionTogglePointerDown(item, $event)"
        (mousedown)="stopMultilineMouseEvent($event)"
        (click)="stopMultilineMouseEvent($event)"
        (keydown)="onMultilineOptionToggleKeydown(item, $event)"
      >
        @for (line of formatMultilineLabel(getOptionLabel(item)); track line) {
        <span>{{ line }}</span>
        }
      </button>
    </ng-template>
    } @else if (selectOptionOnPointerDown) {
    <ng-template ng-option-tmp let-item="item">
      <button
        type="button"
        class="app-select-pointer-option"
        (pointerdown)="onSingleOptionSelectPointerDown(item, $event)"
        (mousedown)="stopMultilineMouseEvent($event)"
        (click)="stopMultilineMouseEvent($event)"
      >
        {{ getDropdownOptionLabel(item) }}
      </button>
    </ng-template>
    } @else if (optionBindLabel) {
    <ng-template ng-option-tmp let-item="item">
      {{ getDropdownOptionLabel(item) }}
    </ng-template>
    }
    @if (multilineOption) {
    <ng-template ng-label-tmp let-item="item" let-label="label">
      <span class="app-select-multiline-label">
        @if (isMultiple) {
        <button
          type="button"
          class="app-select-multiline-value-clear"
          aria-label="ลบรายการที่เลือก"
          [disabled]="_isDisabled"
          (pointerdown)="onMultilineValueClearPointerDown(item, $event)"
          (mousedown)="stopMultilineMouseEvent($event)"
          (click)="stopMultilineMouseEvent($event)"
          (keydown)="onMultilineValueClearKeydown(item, $event)"
        >
          ×
        </button>
        }
        <span class="app-select-multiline-label-text">
          @for (line of formatMultilineLabel(getOptionLabel(item, label)); track line) {
          <span>{{ line }}</span>
          }
        </span>
      </span>
    </ng-template>
    }
  </ng-select>
  <!-- <ng-select
  [id]="name"
  class="{{ inputClass }}"
  [ngClass]="{ error: isError }"
  [appendTo]="appendTo"
  [formControl]="form"
  [items]="options$ | async"
  bindLabel="{{ bindLabel }}"
  bindValue="{{ bindValue }}"
  [placeholder]="placeholder | translate"
  [loading]="isLoading"
  [clearable]="clearable"
  [searchable]="searchable"
  [typeahead]="search$"
></ng-select> -->
  @if (isError) {
  <span class="error">{{ errorMessage | translate }}</span>
  }
</ng-template>

<ng-template #default>
  <div class="form-group" [ngClass]="classes">
    <label
      [for]="name"
      class="py-2 col-form-label fw-semibold fs-6"
      [ngClass]="required ? 'required' : ''"
      >{{ label | translate }}
      @if (addonLabel && addonLabel !== '*') {
      <span class="{{ addonLabelClass }}">({{ addonLabel | translate }})</span>
      } @if (addonLabel && addonLabel === '*') {
      <span class="{{ addonLabelClass }}">{{ addonLabel | translate }}</span>
      }
    </label>
    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>

<ng-template #inline>
  <div class="form-group form-group-inline" [ngClass]="classes">
    <label
      [for]="name"
      class="py-2 col-form-label fw-semibold fs-6"
      [ngClass]="required ? 'required' : ''"
      >{{ label | translate }}</label
    >
    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>
